import React, { useState,useEffect,useContext ,useRef  } from "react";
import $ from "jquery";
import CryptoJS from "react-native-crypto-js";
import ReactGA from 'react-ga4';
import PopupInfo from '../popup/popupInfo';
import Context from '../context/context';

import { useNavigate  } from "react-router-dom";

import helpers from '../_helpers/helpersFunction';


import Pagination from '../pagination/pagination'
import Lang from '../lang/translations';
const config = require("../_helpers/configServizi");


export default function PhotoItem(user) {
	

	const [data, setData] = useState([]);
	// Ripristina la pagina solo se si torna da un profilo aperto dal feed (token findReturn).
	// In tutti gli altri casi (navigazione da navbar, chat, link diretto) si parte da 1.
	const [page, setPage] = useState(() => {
		const raw = sessionStorage.getItem('findReturn');
		if(raw) return JSON.parse(raw).page;
		return 1;
	});

	
	const [modalShow, setModalShow] = useState(false);
	const [header, setHeader] = useState("");
	const [title, setTitle] = useState("");
	const [angelProfile, setProfileId] = useState("");
	const [ImgSrc, setImgSrc] = useState("");
	const [button1, setButton1] = useState("");
	const [button2, setButton2] = useState("");
	const [country, SetCountry] = useState(helpers.getCountry());
	const [totInRegion, setTotInRegion] = useState();
	
	const domain = window.location.hostname;

	var trackerId = localStorage.getItem('trackerId');
	const  context = useContext(Context)
	let navigate = useNavigate();

	const {collection_folder, default_folder} = helpers.getCDNfolder()

	const storico_regione = useRef()
	const storico_pagina = useRef()

	const storico_preferred_age = useRef()

	async function sceltaProfilo(props,tipo){
		if(user.allowed == false){
			return false;
		}

		helpers.kpiPanel(context, null, null, true, null, { canon:"view_profile_detail", dedup:true})

		if(tipo=="profilo"){
			
			/* --- CANCELLARE IN FUTURO ---*/
			const exist = idAlreadyExist(props.id);
			if(!exist){
				var profiliVisitati = localStorage.getItem('profiliVisitati');
				if(profiliVisitati== null){
					localStorage.setItem('profiliVisitati', props.id);
				}else{
					profiliVisitati = profiliVisitati.split(",");
					profiliVisitati.push(props.id);
					localStorage.setItem('profiliVisitati', profiliVisitati.toString());
				}
			}
			/* --- FINE --- */
			helpers.eventPost(localStorage.getItem('trackerId'),props.id,"visita_profilo");
			// Salva pagina e scroll: verrà letto al ritorno per ripristinare la posizione
			sessionStorage.setItem('findReturn', JSON.stringify({ page: page, scrollY: window.scrollY }));
			navigate('/user/'+props.id);
			
		}
		
		if(tipo=="chat"){
			navigate('/chats/'+props.id);
			
		}

		if(tipo=="like"){
			
			var profiliLike = context.profiliLike
			profiliLike.push(props.id)
			context.setProfiliLike(profiliLike)
			const scalo_crediti = (context.flusso.creditiLike && typeof context.flusso.creditiLike === "number") ? true : false
			context.Socket.emit('like', {'trackerId': trackerId, 'angelId':props.id,"servizio": window.location.hostname,"country":country, "screenName":props.screenName, "fluxId": context.fluxId, "scalo_crediti": scalo_crediti });
			helpers.eventPost(localStorage.getItem('trackerId'),props.id,"like_da_home")
		}

		

	}


	
	
	function idAlreadyExist(id){
		var profiliVisitati = localStorage.getItem('profiliVisitati');
		if(profiliVisitati== null){
			return false;
		}
		profiliVisitati = profiliVisitati.split(",");
		if(profiliVisitati.indexOf(id) != -1){  
			return true;
		}
		return false;
	}


	
	

	useEffect(() => {
		//ReactGA.pageview('/find/'+page, "Find");

		context.Socket.on('like', (messaggio) => {
			console.log("Like ricevuto",messaggio.income)
			helpers.kpiPanel(context,"like_da_radar")
			if (messaggio.creditiLike <= 0 && (context.flusso.creditiLike && typeof context.flusso.creditiLike === "number") && context.premiumLevel === 0) {
		
				helpers.showHook("file_like",messaggio.income,context,navigate)
				
				//ReactGA.modalview('/hook/fine_like/'+props.id)
				return
			}else{
				const inviato = Lang( {"w": "mi_piace_inviato","page": "user"} );
				context.setTooltip({visible:true,title:inviato,text:"",variant:"success",autoClose:true,tipo:"like"})
				return
			}

		})
	},[])


	useEffect(() => {
		const currentRegion = context.searchRegion;
		const currentAge = context.user_info.preferred_age;

		context.setModalShowPopupGenerico(false);

		if(storico_regione.current === undefined) {
			//primo mount: carica pagina salvata
			storico_regione.current = currentRegion;
			storico_pagina.current = page;
			storico_preferred_age.current = currentAge;
			chiamaPagina(page);
		} else if(storico_regione.current !== currentRegion || storico_preferred_age.current !== currentAge) {
			// regione o fascia d'età cambiata: reset a pagina 1
			storico_regione.current = currentRegion;
			storico_preferred_age.current = currentAge;
			storico_pagina.current = 1;
			chiamaPagina(1);
			setPage(1);
			localStorage.setItem("page", 1);
		} else if(storico_pagina.current !== page) {
			// Pagina cambiata manualmente
			storico_pagina.current = page;
			chiamaPagina(page);
		}
	}, [context.searchRegion, page, context.user_info.preferred_age, context.seme]);
	


	function rimuoviDalDispenser(id){
		console.log("Rimuovo dal dispenser",id)
		
		fetch(process.env.REACT_APP_DISPENSER + "/del_from_dispenser", {
				method: 'POST',
				headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
				},
				body: JSON.stringify({"country" : country, id:id})
			})
	}


	function makeitsomething(id){
		console.log("Rendo compliant",id)
		fetch(process.env.REACT_APP_DISPENSER + "/makeitcompliant/"+id)
	}


	function chiamaPagina(pagina){
		try{

			//salvo un seme per il random nel local storage. Se non esiste lo creo mentre se esiste lo cambio se sono passati più di 30 minuti
			let seed = localStorage.getItem("dispenserSeed")
			const seedTime = localStorage.getItem("dispenserSeedTime")
			const now = new Date().getTime()
			if(!seed || (seedTime && now - seedTime > 1800000) ){
				seed = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
				localStorage.setItem("dispenserSeed",seed)
				localStorage.setItem("dispenserSeedTime",now)
			}

			const remarketing_clickid = localStorage.getItem('remarketing_clickid') ? localStorage.getItem('remarketing_clickid') : null

			

			fetch(process.env.REACT_APP_DISPENSER, {
				method: 'POST',
				headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
				},
				body: JSON.stringify({"country" : country, "page" : pagina, "vertical": context.flusso.vertical, "region":context.searchRegion, "premiumLevel":context.premiumLevel,"trackerId":trackerId,remarketing_clickid:remarketing_clickid,"city":context.searchCity,"cerco":context.user_info.cerco,preferred_age:context.user_info.preferred_age, seed:seed, servizio: domain})
			})
			.then(response => response.text()) 
			.then(data => {
				let bytes  = CryptoJS.AES.decrypt(data, 'Clav£Inc0ntr1<>!');
				let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
				if(decryptedData.profili.length < 5){
					setPage(1)
					localStorage.setItem("page",1)
					chiamaPagina(1)						
					return
				}

				setData(decryptedData.profili)
				setTotInRegion(decryptedData.totali)
				localStorage.setItem("page",pagina)

				// Ripristina lo scroll se si torna da un profilo aperto dal feed
				const raw = sessionStorage.getItem('findReturn');
				if(raw) {
					sessionStorage.removeItem('findReturn'); // consumato: non si ripete al prossimo mount
					const { scrollY } = JSON.parse(raw);
					setTimeout(() => window.scrollTo({ top: scrollY, behavior: 'smooth' }), 100);
				}
					
				
			})
			.catch((err)=>{
				helpers.logToBackend("Problemi con chiamata dispenser 1",{err:err.message,clickid:trackerId})
			
			})
		
			
		}catch(err){
			helpers.logToBackend("Problemi con chiamata dispenser 2",{err:err.message,clickid:trackerId})
		}
	}


	function display_screenName(angel){

		if(angel.screenName && angel.screenName.length>0){
			return angel.screenName
		}
	}





	
    return (
		<div>
		  <ul> 
			{data.map(el => (
				
				<div className="col-6 col-sm-4 col-md-4 col-lg-2 p-1 d-inline-block p-resp" key={el.id}>
					<div className="card card-search-page">
						{context.user_info?.email === "donna@iumob.com" && <button onClick={() => makeitsomething(el.id)}>No Compliant</button>}	
						<img className="card-img-top" src={process.env.REACT_APP_CDN + "/" + default_folder + "/" + el.id + ".jpg"} alt={el.screenName} onClick={() => sceltaProfilo(el, "profilo")} />  
						<div className="bottomPhoto" ><span>{display_screenName(el)} - { el.age } {Lang( {"w": "anni","page": "photoItem"} )}</span></div>
						<div className="photoItem_buttons">
							<button type="button" className="btn btn-primary" onClick={() => sceltaProfilo(el,"chat")}><i className="fa fa-comments"></i> {Lang( {"w": "bottone_chat","page": "photoItem"} )}</button>
							<button type="button" className={"btn btn-secondary bkg_like" + (context.profiliLike.includes(el.id) ? " liked" : "")} aria-label={Lang( {"w": "bottone_like","page": "photoItem","var": true} )} onClick={() => sceltaProfilo(el,"like")}>
								{context.profiliLike.includes(el.id) ?
									(<svg fill="currentColor" width="16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"/></svg>)
									:
									(<svg fill="currentColor" width="16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"/></svg>)}
							</button>
						</div>
					</div>
					
				</div>
			))}
		  </ul>
		  <div className="text-center">
		  	{context.verifiedUser && ( 
				<>
				<Pagination page={page} totalProfiles={totInRegion} onChangePage={(page) => {setPage(page);document.body.scrollTop = 0;document.documentElement.scrollTop = 0; } } currentPage={page} variant="outlined" color="secondary" size="medium" shape="rounded"/>
				</>
			)}
		  </div>
		<PopupInfo
			show={modalShow}
			onHide={() => setModalShow(false)}
			header={header}
			title={title}
			imagesrc={ImgSrc}
			button1={button1}
			button2={button2}
			angelprofile={angelProfile}
			data-theme={config.servizi[domain].tema}
		 />

	
		 
		
		</div>
	  );

}




